"use strict"
import f from "./frames.json"
import p from "./pilot_gear.json"
import s from "./systems.json"
import w from "./weapons.json"
import t from "./talents.json"

const data = {
  frames: f,
  pilot_gear: p,
  systems: s,
  weapons: w,
  talents: t,
}

export default data;